import { registerPlugin } from '@capacitor/core';
const Ocr = registerPlugin('CapacitorOcr', {});
export * from './definitions';
export { Ocr };
//# sourceMappingURL=index.js.map